import React from 'react'
import POSSystemIntro from '../components/POSSystem/POSSystemIntro'
import POSSystemContent from '../components/POSSystem/POSSystemContent'
import POSSystemFeatures from '../components/POSSystem/POSSystemFeatures'
import Footer from '../components/Footer'
import CollabLogo from '../components/CollabLogo'
import Testimonial from '../components/Testimonial'

const POSSystemPage = () => {
  return (
    <div>
      <POSSystemIntro />
      <POSSystemContent />
      <POSSystemFeatures />
      <Testimonial />
      <CollabLogo />
      <Footer />
    </div>
  )
}

export default POSSystemPage
